module.exports = __webpack_public_path__ + "img/home-page-logo.93691473.png";